export const normalizeSlug = (value = "") =>
  String(value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9áéíóúüñ\s-]/gi, "")
    .replace(/\s+/g, "-");

export const getCanonicalSlugKey = (slug) =>
  normalizeSlug(slug)
    .split("-")
    .filter(Boolean)
    .map((token) => (token.length > 4 && token.endsWith("s") ? token.slice(0, -1) : token))
    .join("-");
